import { updateObject } from "../../../../shared";
import {
  brandPerformanceConstants,
  globalConstants,
  individualGroupPerformanceConstants,
} from "../../constants";

const { SUCCESS, FAILURE } = globalConstants;
const { ALL_GROUP_RESPONSE_DATA, CUSTOMER_RESPONSES_EXPORT_ALL_DATA } =
  individualGroupPerformanceConstants;

const { GROUPS_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING } =
  brandPerformanceConstants;

const initialState = {
  allItemsForExport: [],
  franchiseResponsesData: [],
  allFranchiseResponsesData: [],
  groupResponseDataPagination: {
    size: 10,
    number: 0,
    totalElements: 0,
  },
  groupsAvgSentimentAndTransactionRatingData: {},
};

export const individualGroupPerformanceReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case ALL_GROUP_RESPONSE_DATA + SUCCESS:
      return updateObject(state, {
        allFranchiseResponsesData: action.data.pageData,
        franchiseResponsesData: action.data.pageData.result,
        groupResponseDataPagination: action.data.page,
      });
    case CUSTOMER_RESPONSES_EXPORT_ALL_DATA + SUCCESS:
      return updateObject(state, {
        allItemsForExport: action.data,
      });
    case CUSTOMER_RESPONSES_EXPORT_ALL_DATA + FAILURE:
      return updateObject(state, { allItemsForExport: [] });
    case GROUPS_AVERAGE_SENTIMENT_AND_TRANSACTION_RATING + SUCCESS:
      return updateObject(state, {
        groupsAvgSentimentAndTransactionRatingData: action.data,
      });
    default:
      return state;
  }
};
